module.exports = __webpack_public_path__ + "static/media/loading_indicator_bg@3x.f3e013cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/loading_Indicator/loading_indicator_bg@3x.png
// module id = 456
// module chunks = 0